export default __webpack_public_path__ + "static/media/titleBannerHTPMb.f99777c1.png";